module.exports = __webpack_public_path__ + "assets/img/warrior-name-3afc8f14.png";